module.exports = __webpack_public_path__ + "static/media/garage.a4468cc6.svg";